module.exports = __webpack_public_path__ + "img/menu-light.05e0258.png";